<template>
  <a @click="fileDownload"
     target="_blank"
     class="plain-link">
    <div style="display: flex; justify-content: center">
      <div class="MediaCard"
           style="position: relative;">
        <img ref="media_thumbnail"
             :src="base64Img"
             style="min-width: 100%; max-height: 130px; object-fit: contain"
             alt="Vignette média">
        <h4 class="px-1">{{file_title}}</h4>
      </div>
    </div>
  </a>
</template>

<script>
  import api from 'api'

  export default {
    props: {
      media_url: {
        type: String,
        required: true
      },
      file_title: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        base64Img: null
      }
    },

    computed: {
      file_url: function () {
        return this.media_url + "/file"
      },

      thumbnail_url: function () {
        return this.media_url + "/thumbnail/"
      }
    },

    methods: {
      fileDownload: function () {
        api.get(this.file_url, {responseType: 'blob'})
          .then(result => {
            let link = document.createElement('a')
            let o_url = window.URL.createObjectURL(result.data)
            link.target = "_blank"
            link.type = result.data.type
            link.href = o_url
            link.click()
            window.URL.revokeObjectURL(o_url)
          })
      },

      thumbnailDownload: function () {
        api.get(this.thumbnail_url, {
          responseType: 'arraybuffer'
        }).then(result => {
          this.base64Img = "data:" + result.headers['content-type'] + ";base64," + new Buffer(result.data, 'binary').toString('base64')
        })
      }
    },

    mounted () {
      this.thumbnailDownload()
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .IriadeFileContainer {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 5%;
  }

  .IriadeFile {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
